import firebaseDb from '../firebase';

export { default as firebaseDb } from '../firebase';

export default firebaseDb;
